"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapMetricsReporter = void 0;
function wrapMetricsReporter(metricsReporter, getMetricName) {
    return {
        getMetricName: getMetricName,
        histogram: function (metricName, value) {
            return metricsReporter.histogram(getMetricName(metricName, 'histogram'), value);
        },
        meter: function (metricName) {
            return metricsReporter.meter(getMetricName(metricName, 'meter'));
        },
        reportEndpoint: function (endpoint, duration) {
            return metricsReporter.histogram(getMetricName(endpoint, 'reportEndpoint'), duration);
        },
        reportError: function (err) {
            return metricsReporter.reportError(err);
        },
        runAndReport: function (method, methodName) {
            return metricsReporter.runAndReport(method, getMetricName(methodName, 'runAndReport'));
        },
        runAsyncAndReport: function (method, methodName) {
            return metricsReporter.runAsyncAndReport(method, getMetricName(methodName, 'runAsyncAndReport'));
        },
        reportAsyncWithCustomKey: function (method, methodName, key) {
            return metricsReporter.reportAsyncWithCustomKey(method, getMetricName(methodName, 'reportAsyncWithCustomKey'), key);
        }
    };
}
exports.wrapMetricsReporter = wrapMetricsReporter;
//# sourceMappingURL=wrap-metrics-reporter.js.map